import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  NgModule,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DxButtonModule, DxLoadIndicatorModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { CartService } from 'src/app/shared/services/cart/cart.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { UserService } from 'src/app/shared/services/user/user.service';
import { Router } from '@angular/router';
import { ScreenService } from 'src/app/shared/services/screen.service';

@Component({
  selector: 'app-cart-panel',
  templateUrl: './cart-panel.component.html',
  styleUrls: ['./cart-panel.component.scss'],
})
export class CartPanelComponent implements OnInit, OnDestroy {
  @Output() cartToggle = new EventEmitter<boolean>();

  cart: any;
  itemsInCart = 0;
  itemsInCartC2 = 0;
  loading = false;
  isSalesRepresentative = false;
  isSmall = false;
  isMedium = false;
  isLarge = false;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private userService: UserService,
    private cartService: CartService,
    private sessionService: SessionService,
    private router: Router,
    private screen: ScreenService,
  ) {}

  monitorScreen() {
    this.setScreenStates();
    this.screen.changed.subscribe(() => this.setScreenStates());
  }

  setScreenStates() {
    this.isSmall =
      this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'];
    this.isMedium = this.screen.sizes['screen-medium'];
    this.isLarge =
      this.screen.sizes['screen-large'] || this.screen.sizes['screen-x-large'];
  }

  async ngOnInit() {
    this.monitorScreen();
    await this.getMe();
    this.cartRefreshingCheck();
    this.getCart(false);
    this.getCart(true);
    this.watchPrimaryFacilityUpdatedTrigger();
  }

  async getMe() {
    const result = await this.userService.getMe().toPromise();
    this.isSalesRepresentative = result.data.is_sales_representative;
  }

  watchPrimaryFacilityUpdatedTrigger() {
    this.sessionService.primaryFacilityUpdatedTrigger.subscribe(result =>
      this.onPrimaryFacilityUpdatedTrigger(result),
    );
  }

  onPrimaryFacilityUpdatedTrigger(value) {
    if (value) {
      this.loading = true;
      this.cartService.refresh();
    }
  }

  cartRefreshingCheck() {
    this.cartService.cartRefreshing
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(result => (this.loading = result));
  }

  getCart(isC2) {
    this.cartService
      .get(isC2)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        result => {
          if (isC2) {
            this.itemsInCartC2 = result?.items?.length;
          } else {
            this.itemsInCart = result?.items?.length;
            if (result === null) {
              this.cartService.refresh();
            }
          }
          this.loading = false;
        },
        () => (this.loading = false),
      );
  }

  // Unsubscribe so subscriptions won't fire after view is destroyed
  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  toggleCart() {
    if (this.isSmall) {
      this.router.navigate(['/cart']);
      return;
    }
    this.cartToggle.emit();
  }
}

@NgModule({
  imports: [CommonModule, DxButtonModule, DxLoadIndicatorModule],
  declarations: [CartPanelComponent],
  exports: [CartPanelComponent],
})
export class CartPanelModule {}
